<template>
<v-autocomplete class="text-capitalize" v-model="model" :items="items" :loading="loading" :search-input.sync="search" :label="label" :placeholder="placeholder" :hint="hint" hide-details item-text="name" item-value="id" :menu-props="{transition:'scale-transition'}"
    persistent-hint clearable flat solo return-object no-filter />
</template>

<script>
export default {

    name: `section-search`,

    props: {
        section: Object,
        label: String,
        outline: Boolean,
        details: Boolean,
        placeholder: String,
        persistent: Boolean,
        hint: String,
    },

    data() {
        return {
            model: {
                id: null,
                slug: null,
                name: null
            },
            items: [],
            loading: false,
            search: null,
            search_timeout: 300
        }
    },

    watch: {

        search(val) {

            if(this.model && val === this.model.slug) {
                return;
            }

            clearTimeout(this.search_timeout);
            this.search_timeout = setTimeout(this.getItems(val), 300);
        },

        model() {
            this.$emit('input', this.model);
        },

        section(val) {
            if(!val) {
                return
            }

            this.model = {
                id: val.id,
                slug: val.slug,
                name: val.name
            };

            if(val.id && val.name) {
                this.items = [this.model];
            } else {
                this.items = [];
            }
        }


    },

    methods: {

        getItems(val) {

            // quit early if no search value
            if(!val) {
                return
            }

            // loading
            this.loading = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/destinations/sections';

            // prepare params
            let options = {
                params: {
                    search: val,
                    fields: ['id', 'slug'],
                    size: 5
                }
            };

            // make places search request
            this.$axios.get(endpoint, options)
                .then(response => {
                    this.items = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });

        },

        reset() {
            this.search = null;
            this.items = [];
        }

    }

}
</script>
